import React from 'react';
import styled from '@emotion/styled';
import { DASH_COLORS, DASH_TYPE } from '../../dashboardTokens';
import { SUMMARY_TEXT, ClampedText } from './summariesShared';

// Skenaariot and Tulevaisuuskuvat summary views (design guidance,
// specs/workshop-dashboard.md): every scenario is a round-cornered card that
// carries its color. Skenaariot shows the same card set on the tile and
// expanded (decision 2026-10-19); Tulevaisuuskuvat names the chosen future
// on the tile and adds its variables when expanded.

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: clamp(10px, 1.4vmin, 36px);
  align-items: stretch;
  min-height: 0;
  overflow: hidden;
`;

const ScenarioCard = styled.section`
  flex: 1 1 clamp(200px, 20vw, 520px);
  min-width: 0;
  border-top: clamp(4px, 0.5vmin, 12px) solid ${({ color }) => color || DASH_COLORS.tileBorder};
  background: ${DASH_COLORS.wash};
  border-radius: clamp(8px, 1vmin, 22px);
  padding: clamp(10px, 1.4vmin, 32px);

  h3 {
    margin: 0;
    font-size: ${SUMMARY_TEXT};
    font-weight: 700;
  }
  .chosen {
    margin-top: 0.3em;
    font-size: ${DASH_TYPE.meta};
    color: ${({ color }) => color || DASH_COLORS.text};
    font-weight: 600;
  }
  .chosen.none { color: ${DASH_COLORS.textDim}; font-weight: 400; }
  ul {
    list-style: none;
    margin: clamp(6px, 1vmin, 20px) 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: clamp(4px, 0.7vmin, 16px);
    font-size: ${DASH_TYPE.meta};
    color: ${DASH_COLORS.textDim};
  }
`;

const VariableName = styled.span`
  color: ${DASH_COLORS.text};
  font-weight: 600;
`;

// --- Skenaariot: cards with the tulevaisuuskuva variants, tile = expanded ---

function ScenariosCards({ summary }) {
  return (
    <Cards>
      {summary.breakdown.map((s) => (
        <ScenarioCard key={s.key} color={s.color}>
          <h3>{s.icon ? `${s.icon} ` : ''}{s.label}</h3>
          <ul>
            {s.tulevaisuuskuvat.map((name) => <li key={name}>{name}</li>)}
          </ul>
        </ScenarioCard>
      ))}
    </Cards>
  );
}

// --- Tulevaisuuskuvat (future_selection) ---

function FutureSelectionCards({ t, summary, detail = false }) {
  return (
    <Cards>
      {summary.breakdown.map((s) => (
        <ScenarioCard key={s.key} color={s.color}>
          <h3>{s.label}</h3>
          <div className={`chosen ${s.chosen ? '' : 'none'}`}>{s.chosen || '—'}</div>
          {detail && s.variables.length > 0 && (
            <ul>
              {s.variables.map((v) => (
                <li key={v.name}>
                  <VariableName>{v.name}</VariableName>
                  {' — '}
                  <ClampedText lines={3} style={{ display: 'inline' }}>{v.description}</ClampedText>
                </li>
              ))}
            </ul>
          )}
        </ScenarioCard>
      ))}
    </Cards>
  );
}

function FutureSelectionDetail(props) {
  return <FutureSelectionCards {...props} detail />;
}

export const scenariosView = { Tile: ScenariosCards, Detail: ScenariosCards };
export const futureSelectionView = { Tile: FutureSelectionCards, Detail: FutureSelectionDetail };
